import posthog from 'posthog-js';
import { createContext, useEffect, useState } from 'react';

export const PostHogReady = createContext(false);

export function usePostHogInit() {
  const [ready, setReady] = useState(false);
  useEffect(() => {
    const apiKey = process.env['NEXT_PUBLIC_POSTHOG_KEY'];
    const uiHost = process.env['NEXT_PUBLIC_POSTHOG_UI_HOST'] || 'https://us.i.posthog.com';

    // Until we have dev and staging Project Keys in Posthog, this will only track Prod by default
    if (!apiKey) {
      console.warn(
        'PostHog API key is missing. Please set NEXT_PUBLIC_POSTHOG_KEY in your environment variables.',
      );
      return;
    }

    try {
      posthog.init(apiKey, {
        ui_host: uiHost,
        api_host: '/makeoffalytics/posthog',
        defaults: '2025-05-24',
        person_profiles: 'always',
        disable_session_recording: process.env.NODE_ENV === 'development',
        autocapture: true,
        enable_recording_console_log: true,
        capture_performance: {
          network_timing: true,
          web_vitals: true,
        },
        loaded: (posthog) => {
          if (process.env.NODE_ENV === 'development') posthog.debug();
          setReady(true);
        },
      });
    } catch (error) {
      console.error('Failed to initialize PostHog:', error);
    }
  }, []);
  return ready;
}
